import React, { Fragment } from "react";
import { connect } from "react-redux";

const Block = ({ auth, blocks }) => {
  return (
    <Fragment>
      {blocks &&
        blocks.length > 0 &&
        blocks[0].blocks.map((block) => {
          return (
            <div>
              {block.type === "header" && block.data.level === 1 && (
                <h1 key={block.id}>{block.data.text}</h1>
              )}
              {block.type === "header" && block.data.level === 2 && (
                <h2 key={block.id}>{block.data.text}</h2>
              )}
              {block.type === "header" && block.data.level === 3 && (
                <h3 key={block.id}>{block.data.text}</h3>
              )}
              {block.type === "header" && block.data.level === 4 && (
                <h4 key={block.id}>{block.data.text}</h4>
              )}
              {block.type === "header" && block.data.level === 5 && (
                <h5 key={block.id}>{block.data.text}</h5>
              )}
              {block.type === "header" && block.data.level === 6 && (
                <h6 key={block.id}>{block.data.text}</h6>
              )}
              {block.type === "paragraph" && (
                <p key={block.id}>{block.data.text}</p>
              )}
              {block.type === "table" && (
                <table className="block-center" key={block.id}>
                  {block.data.content.map((row) => (
                    <tr>
                      {row.map((item) => (
                        <td>{item}</td>
                      ))}
                    </tr>
                  ))}
                </table>
              )}
              {block.type === "list" &&
                block.data.style === "ordered" &&
                block.data.items.map((listItem) => (
                  <ol className="block-center">
                    <li key={block.id}>{listItem}</li>
                  </ol>
                ))}
              {block.type === "warning" && (
                <div className="block-center warning" key={block.id}>
                  <p>
                    <i className="fas fa-exclamation-triangle mr-5 red fa-lg"></i>
                    {block.data.title}
                  </p>
                  <p className="block-warning-message">{block.data.message}</p>
                </div>
              )}
              {block.type === "linkTool" && (
                <div className="block-center link-tool green" key={block.id}>
                  <a href={block.data.link} target="_blank">
                    {block.data.link}
                  </a>
                </div>
              )}
              {block.type === "image" && (
                <div className="block-center" key={block.id}>
                  <img className="block-image" src={block.data.file.url} />
                  <p className="block-caption">{block.data.caption}</p>
                </div>
              )}
              {block.type === "quote" && (
                <div className="block-center" key={block.id}>
                  <p>{block.data.text}</p>
                  <p className="block-caption">{block.data.caption}</p>
                </div>
              )}
              {block.type === "checklist" &&
                block.data.items.map((listItem) => (
                  <ol className="block-center">
                    <li key={block.id}>
                      <i className="fas fa-check green fa-lg mr-5"></i>
                      {listItem.text}
                    </li>
                  </ol>
                ))}
            </div>
          );
        })}
    </Fragment>
  );
};

const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default connect(mapStateToProps)(Block);
